import LMSDispatcher from "../LMSDispatcher";
import { IApi, Api } from '../../utilities/Api';
import { ApiRequest } from '../../utilities/ApiRequest';
import * as ACTIONCONTANTS from './ActionConstants';
import ITrendFormData from "../../models/trends/TrendFormData";
import i18next from "i18next";

class TrendActions {
    private readonly api: IApi;

    constructor() {
        this.api = new Api(ACTIONCONTANTS.SAMPLE_ENDPOINT);
    }

   

    async getDateRange(from: any, to: any, requestId: any) {
        try {
            const payload : any= {from: from, to: to};
            const request = new ApiRequest(`/Report/GetTrendsDetail`,requestId,payload, i18next.t("Internal server error!"));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.TREND_RANGE_REPORT,
                payload: {
                    trendDataList: result,
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async GetTrendsPropertiesDetails(data: ITrendFormData, requestId: any): Promise<void> {
        try {
            const payload : any= data;
            const request = new ApiRequest("/Report/GetTrendsPropertiesDetail",requestId, payload, i18next.t("Trend created."));
            const result = await this.api.post(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.TREND_PROPERTY_DETAILS,
                payload: {
                    trendId: result.data,
                    message: result.message
                }
            });

        } catch (error) {
            throw error;
        }
    }

    async PostPropertyValues(data: ITrendFormData, requestId: any): Promise<void> {
        try {
            const payload : any= data;
            const request = new ApiRequest("/Report/GetPropertiesValue",requestId, payload, i18next.t("Propert value posted."));
            const result = await this.api.post(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.TREND_PROPERTY_VALUES,
                payload: {
                    trendIdValue: result.data,
                    message: result.message
                }
            });

        } catch (error) {
            throw error;
        }
    }
    private preparePostPayload(data: ITrendFormData): any {
        const gradeIdCollection: any[] = [];
        const productIdCollection: any[] = [];
       
            if(data.gradeIdCollection){
                gradeIdCollection.push(data.gradeIdCollection)
            }
            if(data.productIdCollection){
                productIdCollection.push(data.productIdCollection)
            }

       
        return {
            productIdCollection: data.productIdCollection,
            gradeIdCollection: data.gradeIdCollection,
            sampleIdCollection: data.sampleIdCollection,
            properties: data.properties,
            sort: data.sort,           
            order: data.order,
            filter: data.filter,
            page: data.page,
            pageSize: data.pageSize
        };
    }
}

const trendActions = new TrendActions();
export default trendActions;